module.exports = __webpack_public_path__ + "static/media/Thirsk-Carved-Font-by-TTF.5a8b90c1.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Thirsk-Carved-Font-by-TTF.eot
// module id = 2987
// module chunks = 70